import type { LinkProps } from '@mui/material/Link';

import { mergeClasses } from 'minimal-shared/utils';

import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { CONFIG } from 'src/global-config';

import { logoClasses } from './classes';
import { useSettingsContext } from '../settings';
import { useAuthContext } from '../../auth/hooks';
import { getDefaultRouteForRole } from '../../auth/guard/role-based-guard';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
};

export function Logo({ sx, disabled, className, href, isSingle = true, ...other }: LogoProps) {
  const settings = useSettingsContext();
  const { user } = useAuthContext();

  // Determinar href según el rol del usuario si no se proporciona uno específico
  const logoHref = href || (user?.role ? getDefaultRouteForRole(user.role) : '/');

  // Determinar el logo según el tema - para el sidebar usamos siempre el logo blanco
  const isDarkMode = settings.state.colorScheme === 'dark';
  const logoSrc = isDarkMode
    ? `${CONFIG.assetsDir}/assets/logo/logo_getalin_dark.png`
    : `${CONFIG.assetsDir}/assets/logo/logo_getalin_dark.png`; // Usar logo blanco también en modo light para el sidebar

  // Logo usando imagen según el tema
  const imageLogo = (
    <img
      alt="Getalink logo"
      src={logoSrc}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      }}
    />
  );

  return (
    <LogoRoot
      component={RouterLink}
      href={logoHref}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: 120,
          height: 120,
          ...(!isSingle && { width: 180, height: 36 }), // Ajustado para el logo de Getalink
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {/* Usar siempre el logo de imagen de Getalink, ignorar isSingle */}
      {imageLogo}
    </LogoRoot>
  );
}

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
